/**
 * Disguise page. Looks like a Chrome connection-failed / coming-soon page.
 *
 * The site is secret — visitors who don't know about the portal should bounce
 * off thinking the page is broken. There IS a way in: the period at the end
 * of the error code (`ERR_CONNECTION_REFUSED.`) is a clickable link to the
 * sign-in portal. The cursor changes on hover; that's the only tell.
 *
 * Anyone who passes their mouse over the page will eventually notice it.
 * Anyone who doesn't can leave thinking nothing's there.
 */

import { useNavigate } from "react-router-dom";

export function BrokenLanding() {
  const nav = useNavigate();

  return (
    <div className="broken-page">
      <div className="broken-card">
        <div className="broken-icon" aria-hidden>
          {/* Plain disconnect/triangle glyph — looks like Chrome's offline page */}
          <svg width="72" height="72" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2 L22 22 L2 22 Z"
              stroke="#5f6368"
              strokeWidth="1.5"
              fill="none"
              strokeLinejoin="round"
            />
            <line x1="12" y1="10" x2="12" y2="15" stroke="#5f6368" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="12" cy="18" r="0.9" fill="#5f6368" />
          </svg>
        </div>

        <h1 className="broken-title">This site can&rsquo;t be reached</h1>

        <p className="broken-lead">
          The connection was refused or the site is temporarily unavailable.
        </p>

        <ul className="broken-suggestions">
          <li>Checking the connection</li>
          <li>Checking the proxy and the firewall</li>
          <li>Running Windows Network Diagnostics</li>
        </ul>

        <p className="broken-code">
          {/* The trailing period is the secret entry button. Indistinguishable
              from punctuation; cursor: pointer is the only visible cue. */}
          <span className="broken-code-text">ERR_CONNECTION_REFUSED</span>
          <span
            className="broken-portal"
            role="button"
            tabIndex={0}
            aria-label="Open portal"
            title=""
            onClick={() => nav("/portal")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") nav("/portal");
            }}
          >.</span>
        </p>

        <div className="broken-actions">
          <button className="broken-reload" onClick={() => window.location.reload()}>
            Reload
          </button>
          <button className="broken-details">Details</button>
        </div>
      </div>
    </div>
  );
}
